import { api, cachedRequest } from '../apiClient';
import { HomeData } from '../../types';

export const homeService = {
  getHomeData: async (forceRefresh: boolean = false): Promise<HomeData> => {
    return cachedRequest(
      'home_data',
      async () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('Making API request to /home/ for events filtered by country');
        }
        const response = await api.get('/home/');
        if (process.env.NODE_ENV === 'development') {
          console.log('Home API response received:', {
            eventsCount: response.data.events?.length || 0,
            activitiesCount: response.data.activity_places?.length || 0,
            highlightsCount: response.data.highlight_events?.length || 0
          });
        }
        return response.data;
      },
      5 * 60 * 1000, // 5 minutes
      forceRefresh
    );
  },
};

